// ResultsTable.jsx
import { useState, useEffect } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import ChallengeCarousel from './ChallengeCarousel';
import ActionButtons from './ActionButtons';
import ParticipantsTable from './ParticipantsTable';
import ParticipantModal from './ParticipantModal';
import FAQModal from './FAQModal';
import Footer from './Footer';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import NBLRLogo from '../assets/nblrs.png';
import mileStoneImage from '../assets/milestones.png';

const MainApp = () => {


  const [participants, setParticipants] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSlides, setLightboxSlides] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [faqOpen, setFaqOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('/santassack');
      if (!response.ok) throw new Error('Failed to fetch data');
      const data = await response.json();
      setParticipants(data.participants);
      setChallenges(data.challenges);
      setCurrentMonth(data.currentMonth);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }; 

  const calculateTotal = (days) => {
    let total = 0;
    for (let i = 1; i <= 25; i++) {
      const day = days[`day${i}`];
      if (day && day.body) {
        total += parseFloat(day.body) || 0;
      }
    }
    return total.toFixed(1);
  };

  const getChallengeTitle = (dayNumber) => {
    const challenge = challenges.find(c => c.id === dayNumber);
    return challenge ? challenge.challengeTitle : '';
  };

  const getParticipantImages = (participant) => {
    const images = [];
    for (let i = 1; i <= 25; i++) {
      const dayKey = `day${i}`;
      const dayData = participant.days[dayKey];
      if (dayData && dayData.image_url) {
        const challengeTitle = getChallengeTitle(i);
        images.push({
          src: dayData.image_url,
          title: participant.participantName + ` - Day ${i}`,
          description: `${dayData.body} miles${challengeTitle ? ` - ${challengeTitle}` : ''}`
        });
      }
    }
    return images;
  };

  const openLightbox = (participant, dayNumber) => {
    const slides = getParticipantImages(participant);
    setLightboxSlides(slides);
    
    let clickedIndex = 0;
    for (let i = 1; i <= dayNumber; i++) {
      const dayKey = `day${i}`;
      const dayData = participant.days[dayKey];
      if (dayData && dayData.image_url) {
        if (i === dayNumber) break;
        clickedIndex++;
      }
    }
    
    setLightboxIndex(clickedIndex);
    setLightboxOpen(true);
  };

  const openModal = (participant) => {
    setSelectedParticipant(participant);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedParticipant(null);
  };

  const getCurrentChallengeDay = () => {
    if (challenges.length === 0) {
      return 1;
    } else {
      return challenges.length;
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl">Loading event data...</div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl text-red-600">Error: {error}</div>
      </div>
    );
  }

  return (
    <>
    <div className="tenBlock">
      <img src={NBLRLogo} alt="NBLR Logo" className="nblrLogo" />

      <h1 className="mileStonesHeader">Milestones</h1>
      <h1 className="mileStonesHeaderTwo">Challenge</h1>

      <ActionButtons onFaqClick={() => setFaqOpen(true)} />
      
      {/* <ChallengeCarousel challenges={challenges} /> */}

      <p className='introText'>Run 10 or 20 miles every month in 2026 <br className='hideMobile'/>...without running the same path twice.</p>
      <ParticipantsTable 
        participants={participants}
        challenges={challenges}
        currentMonth={currentMonth}
        calculateTotal={calculateTotal}
        openLightbox={openLightbox}
        openModal={openModal}
      />

      <Footer showFooter={participants.length > 0} />

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
        plugins={[Captions]}
        controller={{ closeOnBackdropClick: true }}
        carousel={{ finite: lightboxSlides.length <= 1 }}
        render={{
          buttonPrev: lightboxSlides.length <= 1 ? () => null : undefined,
          buttonNext: lightboxSlides.length <= 1 ? () => null : undefined,
        }}
      />

      <ParticipantModal 
        isOpen={modalOpen}
        participant={selectedParticipant}
        onClose={closeModal}
        calculateTotal={calculateTotal}
        getCurrentChallengeDay={getCurrentChallengeDay}
        openLightbox={openLightbox}
      />

      <FAQModal 
        isOpen={faqOpen}
        onClose={() => setFaqOpen(false)}
      />
    </div>
    <div className="fullWidthFooter">

        Created by <a href="https://realtimeracing.co.uk">RealtimeRacing</a>

    </div>
    </>
  );
}

export default MainApp;
